// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"ea1d5292","455":"43d73220","977":"d40a94a6"}[chunkId] + ".chunk.js";
};